import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Brand } from '../components/common/Brand';
import { Seo } from '../components/Seo';

// Landing page the auth server redirects to after an email-verification click
// (/api/auth/verify-email -> 303 -> /verified?status=...).
const MESSAGES: Record<string, { emoji: string; title: string; msg: string; ok: boolean }> = {
  success: { emoji: '🎉', title: 'Email verified!', msg: 'Your account is ready. You can now sign in.', ok: true },
  already: { emoji: '✅', title: 'Already verified', msg: 'Your email was already verified — go ahead and sign in.', ok: true },
  expired: { emoji: '⏰', title: 'Link expired', msg: 'That verification link has expired. Sign in to request a new one.', ok: false },
  invalid: { emoji: '⚠️', title: 'Invalid link', msg: "We couldn't find that verification link. It may have already been used.", ok: false },
  error: { emoji: '⚠️', title: 'Something went wrong', msg: 'Please try again in a moment.', ok: false },
};

export const Verified: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const s = MESSAGES[params.get('status') || 'success'] || MESSAGES.success;

  return (
    <div className="auth auth-center">
      <Seo title="Email verification — Local Area Cloud" description="Email verification status for your Local Area Cloud account." path="/verified" noindex />
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-brand"><Brand variant="full" height={64} /></div>
        <div style={{ fontSize: 52, lineHeight: 1, marginBottom: 14 }}>{s.emoji}</div>
        <span className={s.ok ? 'auth-badge ok' : 'auth-badge'} style={{ marginBottom: 14 }}>
          {s.ok ? 'Verified' : 'Action needed'}
        </span>
        <h1 className="auth-title" style={{ marginTop: 14 }}>{s.title}</h1>
        <p className="auth-sub">{s.msg}</p>
        <button className="auth-btn" onClick={() => navigate('/login')}>Continue to sign in</button>
      </div>
    </div>
  );
};

export default Verified;
